module.exports = __webpack_public_path__ + "img/table-3.26599656.jpg";